import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by 辅希"
      links={[
        {
          key: 'Hydrop Manager',
          title: '水培蔬菜设备管理系统',
          href: '#',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
